import React, { Component } from "react";
import { getProviderByTerm } from "../shared/data";

export const WithAsync = (WrappedInput) => {
    return class Async extends Component {
        constructor(props) {
            super(props);

            this.state = {
                options: [],
            };

            this.loadTimeout = null;
        }

        onChange = (e) => {
            const inputValue = e.currentTarget.value;

            if (this.props.loadOptions || this.props.provider) {
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.loadOptions(inputValue);
                }, 400);
            }

            if (this.props.onChange) {
                this.props.onChange(e);
            }
        };

        loadOptions = async (inputValue) => {
            const value = inputValue ? inputValue.trim() : "";

            const options = value ? (this.props.provider ? await getProviderByTerm(value, this.props.provider, this.props.tags) : await this.props.loadOptions(value)) : [];

            // Catch for success or failure
            if (options.success || options.error) {
                return;
            }

            this.setState({
                options,
            });
        };
        render() {
            return <WrappedInput {...this.props} async={true} filterable={false} onChange={this.onChange} options={this.state.options} getOptions={this.loadOptions} />;
        }
    };
};
